import { render } from "./FooterView.vue?vue&type=template&id=5e0226a7&scoped=true"
const script = {}

import "./FooterView.vue?vue&type=style&index=0&id=5e0226a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0226a7"]])

export default __exports__